import(/* webpackMode: "eager", webpackExports: ["CourseDetailClient"] */ "/vercel/path0/src/features/courses/components/course-detail-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePasswordGate"] */ "/vercel/path0/src/features/courses/components/course-password-gate.tsx");
